function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8958 11.9474C10.6721 11.7438 6.89677 8.54559 5.66208 6.97195C3.85754 9.93409 5.89161 12.4642 7.13421 13.3591C6.64034 13.4146 5.4563 13.0428 4.92602 12.8499C5.09697 16.1083 7.65658 17.3703 8.91501 17.594C8.23119 17.7976 7.18962 17.7868 6.75431 17.756C7.62809 20.3849 10.1734 21.0421 11.3369 21.0421C9.15246 23.0045 5.53545 23.2483 4 23.1249C8.77255 25.9019 16.1332 26.4573 21.3806 21.5049C24.806 17.745 25.5916 15.3477 25.797 10.7672C27.1457 9.82301 27.9419 8.73843 28.1714 8.31417C27.5826 8.64741 26.1215 8.91585 25.4646 9.00842C26.6803 8.37897 27.3641 7.00281 27.5541 6.39341C26.8513 6.89327 25.1718 7.37307 24.4199 7.55049C23.2077 6.42412 22.3711 6.12754 20.6921 6C17.1542 6.20828 15.3971 8.80014 15.8958 11.9474Z",
  fill: "#959698"
});

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.565bb955.svg";
export { ForwardRef as ReactComponent };